import { createUseStyles } from 'react-jss'
import { PAGE_WRAPPER_TITLE_CLASSNAME } from '../../../../../constants/pdf'

const useStyles = createUseStyles({
  [PAGE_WRAPPER_TITLE_CLASSNAME]: {
    fontSize: 16,
    fontWeight: 700,
    margin: 20,
    marginBottom: 0
  }
})

export default useStyles
